module.exports = __webpack_public_path__ + "static/img_5041-f241965bc5c848c93b9bb458cde5bd3f.webp";